import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { SafeUrlPipe } from 'src/app/shared/pipes/safe-url.pipe';

import { LocationListModule } from 'src/app/shared/location-list/location-list.module';

@Component({
  selector: 'app-region-card-mobile',
  templateUrl: './region-card-mobile.component.html',
  styleUrls: ['region-card-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, SafeUrlPipe, LocationListModule],
})
export class RegionCardMobileComponent {
  @Input() countryName: string = '';
  @Input() region: any = {};
  @Output() onShowCities = new EventEmitter<string>();
  @Output() onHideCities = new EventEmitter<string>();

  protected isViewCities: boolean = false;

  protected toggleView(): void {
    this.isViewCities = !this.isViewCities;

    if (this.isViewCities) {
      this.onShowCities.emit(this.region.region_id);
    } else {
      this.onHideCities.emit(this.region.region_id);
    }
  }
}
